export const SHOW_HINT = "Enter $ symbol to see available parameters";
